// Metres, +Y up, north = -Z. All rendered solids, support planes and navigation
// derive from these immutable dimensions. This is a virtual, unpowered maquette.
const house={x:-8,z:0,width:10,depth:8,height:3.2,thickness:.18,minX:-13,maxX:-3,minZ:-4,maxZ:4};
const door={x:-6,z:4,width:1.5,height:2.45,thickness:.055,minX:-6.75,maxX:-5.25,hingeX:-6.75,openAngle:Math.PI/2};
const bench={x:-10.35,z:-1.65,width:2.4,depth:.9,top:.9,slab:.08,leg:.08,inset:.12};
// Centre and per-axis tolerance in metres; shared by the guide and the reducer.
const guidedKit={tolerance:.02,colors:{
 frame:{material:'blue',labels:{fr:'bleu',en:'blue'}},
 'breaker-b':{material:'coral',labels:{fr:'rouge',en:'red'}},
 driver:{material:'sage',labels:{fr:'vert',en:'green'}},
 'breaker-a':{material:'amber',labels:{fr:'jaune',en:'yellow'}},
 differential:{material:'ink',labels:{fr:'foncé',en:'dark'}},
},targets:{
 frame:{x:-11.190194418653846,z:-1.7299993129447102},
 differential:{x:-9.35,z:-1.84},
 'breaker-a':{x:-9.556639372371137,z:-1.9039272795198485},
 'breaker-b':{x:-9.818947901204227,z:-1.707862922293134},
 driver:{x:-9.681580849178134,z:-1.7724382888991386},
}};
const cabinet={x:-7.9,y:1.66,backZ:-3.90,width:.504,height:.75,depth:.216,module:.036,railPitch:.25,scale:2};
const van={width:1.95,length:4.7,height:2.45,park:{x:-6,z:10,yaw:Math.PI/2},seat:{x:.52,y:.52,z:-1.08}};
// Conservative physical footprints for the actual local furniture models.
// Both sit against the east wall, away from entry, bench and the board route.
const furniture={chair:{x:-4.15,z:1.05,width:.95,depth:.90,height:1.60},table:{x:-4.48,z:-1.35,width:1.45,depth:1.45,height:1.02}};
const footprint=(o,width=o.width,depth=o.depth)=>({minX:o.x-width/2,maxX:o.x+width/2,minZ:o.z-depth/2,maxZ:o.z+depth/2});
const wall=(id,minX,maxX,minZ,maxZ,height=house.height,minY=0)=>({id,minX,maxX,minZ,maxZ,minY,height});
const t=house.thickness/2;
const solids=[
 wall('wall-west',house.minX-t,house.minX+t,house.minZ-t,house.maxZ+t),
 wall('wall-east',house.maxX-t,house.maxX+t,house.minZ-t,house.maxZ+t),
 wall('wall-north',house.minX-t,house.maxX+t,house.minZ-t,house.minZ+t),
 wall('wall-south-left',house.minX-t,door.minX,house.maxZ-t,house.maxZ+t),
 wall('wall-south-right',door.maxX,house.maxX+t,house.maxZ-t,house.maxZ+t),
 wall('door-lintel',door.minX,door.maxX,house.maxZ-t,house.maxZ+t,house.height-door.height,door.height),
 wall('open-door',door.minX-door.thickness/2,door.minX+door.thickness/2,door.z-door.width,door.z,door.height),
 {id:'bench',...footprint(bench),minY:0,height:bench.top},
 {id:'furniture-chair',...footprint(furniture.chair),minY:0,height:furniture.chair.height},
 {id:'furniture-table',...footprint(furniture.table),minY:0,height:furniture.table.height},
 wall('cabinet',cabinet.x-cabinet.width/2,cabinet.x+cabinet.width/2,cabinet.backZ,cabinet.backZ+cabinet.depth,cabinet.height,cabinet.y-cabinet.height/2),
 wall('parked-van',van.park.x-van.length/2,van.park.x+van.length/2,van.park.z-van.width/2,van.park.z+van.width/2,van.height),
];
const itemDimensions={
 driver:{width:.055,height:.055,depth:.31},pliers:{width:.15,height:.048,depth:.29},
 frame:{width:.45,height:.035,depth:.61},differential:{width:.07,height:.18,depth:.123},
 'breaker-a':{width:.034,height:.18,depth:.123},'breaker-b':{width:.034,height:.18,depth:.123},
};
// +X is the passenger side. At parked yaw PI/2 it faces north (-Z).
const spawn={x:van.park.x+van.seat.z,z:van.park.z-1.95,yaw:0,pitch:0};
function freeze(v){if(v&&typeof v==='object'){Object.values(v).forEach(freeze);Object.freeze(v);}return v;}
export const layout=freeze({
 eyeHeight:1.65,speed:2.1,radius:.23,house,door,bench,guidedKit,cabinet,van,furniture,solids,itemDimensions,
 bounds:{minX:-22,maxX:7,minZ:-9,maxZ:34},spawn,
 route:{start:{x:0,z:96},turn:{x:0,z:12},park:van.park,width:4.8,speed:6},
 // Walk around the rear/east end, away from both forward-hinged open cab doors.
 mentor:{exit:{x:-7.08,z:11.65},waypoints:[{x:-2.95,z:11.65},{x:-2.95,z:7.6},{x:-6,z:4.65},{x:-6,z:3.15},{x:-7.65,z:1.5},{x:-8.6,z:-.30}],board:{x:cabinet.x-.63,z:-3.05},waitDistance:3.3},
 playerRoute:[{x:-6,z:6.5},{x:-6,z:5.2},{x:-6,z:2.5},{x:-9.35,z:.45}],
 toolbox:{x:bench.x,y:bench.top,z:bench.z,width:.96,depth:.72,height:.18},
 anchors:[{id:'yard',x:-5.5,z:7},{id:'entry',x:-6,z:2.2},{id:'kit',x:-9.6,z:-.35},{id:'board',x:-7.65,z:-2.65}],
 driver:{length:.31,bladeLength:.024,shaftEnd:.178,shaftRadius:.003,bladeWidth:.008,bladeThickness:.0018,
 handleProfile:[[0,.178],[.009,.178],[.013,.187],[.024,.215],[.026,.24],[.023,.285],[.016,.307],[0,.31]]},
});
